import { useEffect, useState } from "react";
import { FlaskConical, EyeOff } from "lucide-react";
import { productApi } from "@/lib/api";

export function useProductMode() {
  const [mode, setMode] = useState(null);
  useEffect(() => { productApi.getMode().then((r) => setMode(r.data.mode)).catch(() => setMode("real")); }, []);
  return mode;
}

export function ProductModeBanner({ className = "" }) {
  const mode = useProductMode();
  if (!mode) return null;
  const sandbox = mode === "sandbox";
  return (
    <div
      className={`rounded-lg border px-4 py-2.5 flex items-center gap-2 ${sandbox ? "border-violet-200 bg-violet-50" : "border-teal-200 bg-teal-50"} ${className}`}
      data-testid="product-mode-banner"
      data-mode={mode}
    >
      {sandbox ? <FlaskConical size={16} className="text-violet-600" /> : <EyeOff size={16} className="text-teal-600" />}
      <span className={`text-xs font-semibold ${sandbox ? "text-violet-700" : "text-teal-700"}`}>
        {sandbox ? "Sandbox — synthetic data." : "Live data — web-indexing revenue hidden."}
      </span>
      <span className={`text-xs ${sandbox ? "text-violet-500" : "text-teal-600"}`}>
        {sandbox ? "Nothing here is real. Your admin controls this mode." : "Aniview & SpringServe revenue is real. Web-indexing earnings show as Unavailable."}
      </span>
    </div>
  );
}
